import React from "react";
import theme from "../../styles/theme/theme";
import "./styles.css"
const Loader = ({ message = "Loading..." }) => {
  return (
    <div style={styles.overlay}>
      <div style={styles.loaderBox}>
        <div style={styles.spinner}></div>
        <p style={styles.message}>{message}</p>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  loaderBox: {
    backgroundColor: "#fff",
    padding: "24px 36px",
    borderRadius: "10px",
    border: `1px solid #e0e0e0`, // Soft border instead of shadow
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
  spinner: {
    width: "40px",
    height: "40px",
    border: "3px solid transparent",
    borderTop: `3px solid ${theme.palette.primary.main}`,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  message: {
    margin: 0,
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
};

export default Loader;
